import camelCase from "lodash/camelCase";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import { Select } from "PFComponents/select";
import { Option } from "PFTypes/options";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { humanize } from "underscore.string";

import { useNotificationsPanelContext } from "../contexts/notifications_panel_context";
import { useNotificationsMetadata } from "../hooks/use_notifications_metadata";

type NotificationTypeSelectProps = {
  disabled?: boolean;
};

export const NotificationTypeSelect = ({ disabled }: NotificationTypeSelectProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "notifications.filters" });
  const { t: tNotifications } = useTranslation("notificationsSettings", { keyPrefix: "category" });

  const { categories, setCategories } = useNotificationsPanelContext();
  const { availableCategories } = useNotificationsMetadata();

  const handleCategoryChange = useCallback(
    (items: Option<string>[]) => {
      setCategories(items.map(({ original }) => original));
    },
    [setCategories]
  );

  const dropdownOptions: Option<string>[] = useMemo(
    () =>
      orderBy(
        map(availableCategories, (categoryKey) => {
          const label = tNotifications(camelCase(categoryKey) as unknown as TemplateStringsArray, {
            defaultValue: humanize(categoryKey)
          });
          return {
            id: categoryKey,
            value: label,
            displayElement: label,
            original: categoryKey
          };
        }),
        "displayElement"
      ),
    [tNotifications, availableCategories]
  );

  return (
    <Select<string>
      onClear={categories.length ? () => setCategories([]) : undefined}
      label={t("type")}
      value={categories}
      options={dropdownOptions}
      onChange={handleCategoryChange}
      disabled={disabled}
      multiple
    />
  );
};
